import React, { Component } from 'react';
import './NavMobile.scss';
import AriaModal from 'react-aria-modal';
import { Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import posed, { PoseGroup } from 'react-pose';
import { CloseButton } from '../index';
import { IconFacebook, IconInstagram, IconTwitter, IconYoutube } from '../../icons';

const PoseUL = posed.ul({
  preEnter: {
    opacity: 0,
    height: '0px'
  },
  enter: {
    opacity: 1,
    height: '274px',
    transition: {
      height: { type: 'spring', stiffness: 1000, damping: 20 },
      default: { duration: 900 }
    },
    delay: 400
  }
});

export default class NavMobile extends Component {
  constructor(props) {
    super(props);
    this.state = { open: true };
  }

  render() {
    const { additionalNavItems = [] } = this.props;

    return (
      <CSSTransition
        in={this.state.open}
        appear
        classNames="overlay overlay"
        key={'mobile-nav-overlay'}
        timeout={300}
      >
        <AriaModal
          titleText="Nike SB Mobile Navigation"
          initialFocus="#close"
          getApplicationNode={this.props.getApplicationNode}
          underlayStyle={{ background: 'white' }}
          underlayClass="mobile-nav--underlay"
          dialogStyle={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            textAlign: 'unset'
          }}
          dialogClass="mobile-nav--dialog"
        >

          <div className="mobile-nav__header">
            <img
              alt=""
              className="nav__logo nav__logo--large"
              src="/icons/nav/logo_nikesb_Black.svg"
            />

            <div className="nav__shop nav__shop--mobile">
              <a
                href="https://www.nike.com/w/skateboarding-8mfrf"
                className="nav__highlight"
                target="blank"
                data-track-click={JSON.stringify({
                  event_action: "Shop from nav",
                  event_category:     'Shop Nike.com',
                  event_label:        'Shop from nav: Top Nav'
                })}
              >
                <span className="arrow" />
                Shop Nike SB
              </a>
            </div>

            <CloseButton
              className="btn--close icon"
              title="close navigation button"
              onClick={() => {
                this.setState({ open: false });
                setTimeout(this.props.closeModal, 550);
              }}
            />
          </div>

          <div
            className="mobile-nav__hamburger"
            onClick={() => {
              setTimeout(this.props.closeModal, 550);
            }}
          >
            <svg className="mobile-nav__hamburger__bun-top" aria-hidden="true" viewBox="0 0 250 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M150.186 52.7662C153.329 52.7755 156.405 49.6945 156.399 46.5427C156.393 43.4244 153.269 40.2437 150.203 40.2344C147.174 40.2251 143.978 43.4439 143.96 46.5212C143.943 49.6088 147.08 52.756 150.186 52.7662ZM108.916 27.5801C112.09 27.5344 115.002 24.4692 114.965 21.2122C114.928 17.9766 111.896 14.9635 108.737 15.0203C105.675 15.0762 102.494 18.3602 102.565 21.3928C102.637 24.5092 105.837 27.6247 108.916 27.5801ZM86.3079 46.4645C86.2756 49.6898 89.1939 52.7113 92.3868 52.7569C95.494 52.8016 98.6519 49.727 98.6989 46.6125C98.7441 43.564 95.577 40.2921 92.5343 40.2428C89.4842 40.1934 86.3392 43.3359 86.3079 46.4645ZM183.096 38.0175C183.12 41.3806 185.843 44.1582 189.042 44.0884C192.447 44.0139 195.521 41.0017 195.483 37.7801C195.446 34.6544 192.23 31.5417 189.122 31.6226C185.893 31.7064 183.071 34.7018 183.096 38.0175ZM35.5453 83.4838C38.7475 83.4651 41.7275 80.4018 41.6703 77.1867C41.6159 74.0218 38.4424 70.8803 35.3766 70.9585C32.3063 71.0357 29.1576 74.2964 29.2046 77.3496C29.2526 80.4762 32.381 83.5033 35.5453 83.4838ZM118.898 80.3507C122.395 80.4019 125.115 77.7983 125.18 74.3384C125.241 71.0917 122.352 68.0227 119.144 67.9278C116.056 67.8365 112.815 70.8953 112.712 73.9959C112.611 77.0257 115.804 80.3051 118.898 80.3507ZM195.498 70.9055C198.671 70.9018 201.615 67.8813 201.606 64.6364C201.599 61.4864 198.583 58.3895 195.454 58.3216C192.113 58.249 189.164 61.263 189.212 64.7015C189.254 67.8319 192.372 70.9093 195.498 70.9055ZM222.032 86.6985C225.197 86.7041 228.292 83.4909 228.286 80.2059C228.281 77.1156 225.329 74.163 222.218 74.1369C218.95 74.109 215.797 77.217 215.816 80.4461C215.834 83.6063 218.903 86.6929 222.032 86.6985ZM83.1531 83.469C86.6097 83.4942 89.2311 80.8757 89.2707 77.3609C89.3058 74.1914 86.2797 71.008 83.19 70.9614C80.1501 70.9167 76.9212 74.0332 76.8023 77.1273C76.6797 80.3033 79.8275 83.4467 83.1531 83.469ZM58.8833 50.4328C61.9969 50.47 65.1438 47.3238 65.1465 44.1711C65.1493 41.0751 61.9481 37.8153 58.9192 37.8321C55.8074 37.8489 52.691 40.9932 52.6652 44.1394C52.6403 47.3154 55.6839 50.3946 58.8833 50.4328ZM168.889 72.5786C168.865 69.3802 165.819 66.2256 162.756 66.2266C159.66 66.2275 156.464 69.3672 156.417 72.451C156.366 75.7387 159.645 78.8784 163.064 78.8189C166.265 78.763 168.914 75.9249 168.889 72.5786ZM150.14 27.5925C153.223 27.625 156.36 24.5095 156.398 21.3764C156.435 18.2581 153.36 15.0737 150.271 15.0318C146.905 14.9871 144.042 17.7172 143.962 21.0431C143.886 24.288 146.972 27.5589 150.14 27.5925ZM249.951 100H0C0.752144 94.1339 1.09872 88.4055 2.26842 82.854C6.16832 64.3705 15.8153 49.156 29.1705 36.1839C46.0421 19.7966 66.3408 9.92511 88.8618 4.34291C102.955 0.848559 117.3 -0.54583 131.764 0.19139C164.628 1.86689 194.309 12.1805 219.115 34.6257C234.305 48.3713 244.744 65.1598 248.735 85.6289C249.34 88.7323 249.62 91.9073 249.924 95.0629C250.078 96.6555 249.951 98.278 249.951 100Z" fill="#DD9B0D"/>
            </svg>

            <PoseGroup animateOnMount={true} preEnterPose={'preEnter'}>
              <PoseUL
                className="nav__list mobile-nav__list"
                animateOnMount={true}
                preEnterPose={'preEnter'}
                key="ul"
              >
                <li key="lettuce">
                  <Link
                    className="burger-nav mobile-nav--highlight mobile-nav--highlight--lettuce"
                    to="/"
                  >
                    <span className="mobile-nav__hamburger-text">Feed</span>
                  </Link>
                </li>
                <li key="tomato">
                  <Link
                    className="burger-nav mobile-nav--highlight mobile-nav--highlight--tomato"
                    to="/team"
                  >
                    <span className="mobile-nav__hamburger-text">Team</span>
                  </Link>
                </li>
                <li key="cheese">
                  <Link
                    className="burger-nav mobile-nav--highlight mobile-nav--highlight--cheese"
                    to="/the-vault"
                  >
                    <span className="mobile-nav__hamburger-text">The Vault</span>
                  </Link>
                </li>
                <li key="patty">
                  <Link
                    className="burger-nav mobile-nav--highlight mobile-nav--highlight--patty"
                    to="/shops"
                  >
                    <span className="mobile-nav__hamburger-text">
                      Skateshops
                    </span>
                  </Link>
                </li>

                {(additionalNavItems && additionalNavItems.length > 0) && additionalNavItems.map((navLink, i) => {
                  if(navLink && navLink.customText && navLink.value) {
                    let topping = i === 0 ? 'onion' : 'sauce';
                    return(
                      <li key={topping}>
                        {navLink.type === 'entry' ?
                          <Link
                            className={`burger-nav mobile-nav--highlight mobile-nav--highlight--${topping}`}
                            to={navLink.value}
                          >
                            <span className="mobile-nav__hamburger-text">
                              {navLink.customText}
                            </span>
                          </Link>
                        :
                          <a className={`burger-nav mobile-nav--highlight mobile-nav--highlight--${topping}`} target={navLink.target} href={navLink.value}>{navLink.customText}</a>
                        }
                      </li>
                    );
                  }

                  return null;
                })}
              </PoseUL>
            </PoseGroup>

            <svg className="mobile-nav__hamburger__bun-bottom" aria-hidden="true" viewBox="0 0 250 45" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0H249.992C250.135 6.57426 248.444 12.7476 245.071 18.5397C237.307 31.8678 224.458 40.0929 206.945 43.2906C203.304 43.9553 199.476 44.1773 195.734 44.1826C148.611 44.2395 101.487 44.2417 54.3647 44.2114C28.0308 44.1948 6.03817 29.2651 1.05557 8.03706C0.448434 5.45329 0.353395 2.78993 0 0Z" fill="#DD9B0D"/>
            </svg>

          </div>

          <div className="mobile-nav__footer">
            <div className="mobile-nav__social">
              <IconYoutube />
              <IconTwitter />
              <IconInstagram />
              <IconFacebook />
            </div>
          </div>
        </AriaModal>
      </CSSTransition>
    );
  }
}
